import { render, staticRenderFns } from "./residentDialog.vue?vue&type=template&id=15015712&scoped=true&"
import script from "./residentDialog.vue?vue&type=script&lang=js&"
export * from "./residentDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15015712",
  null
  
)

export default component.exports